import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface PermissionRequest {
  center_id: number;
  module_id: number;
  sub_module_id?: number;
}

interface PermissionData {
  id: number;
  user_id: number;
  user_center_id: number;
  center_id: number;
  module_id: number;
  sub_module_id: number;
  can_create: boolean;
  can_read: boolean;
  can_delete: boolean;
  can_update: boolean;
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
}

interface PermissionResponse {
  data: PermissionData[];
}

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private authUrl = 'http://localhost:3000/';
  private http = inject(HttpClient);

  getPermissions(request: PermissionRequest): Observable<PermissionResponse> {
    // Debug: Log cookie information
    console.log('Available cookies:', document.cookie);
    console.log('Auth token from localStorage:', this.getAuthToken());
    
    return this.http.post<PermissionResponse>(this.authUrl + 'permission/get', request, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAuthToken()}`,
      },
    });
  }

  private getAuthToken(): string {
    
    //try to get from cookies
    const cookieToken = this.getCookie('access_token');
    if (cookieToken) {
      return cookieToken;
    }
    
    return '';
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  }

  setAuthToken(token: string): void {
    localStorage.setItem('authToken', token);
  }

  clearAuthToken(): void {
    localStorage.removeItem('authToken');
    // Also clear any cookies if needed
    document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  // Check if user has read permission for a module
  hasReadPermission(moduleId: number, subModuleId?: number): Observable<boolean> {
    return this.getPermissions({
      center_id: 1, // This should come from the saved data in indexedDB
      module_id: moduleId,
      sub_module_id: subModuleId
    }).pipe(
      map(response => {
        if (!response.data || response.data.length === 0) {
          return false;
        }
        
        // Check if user has read permission and is not deleted
        // const permission = response.data.find(p => 
        //   p.module_id === moduleId && 
        //   (!subModuleId || p.sub_module_id === subModuleId) &&
        //   !p.is_deleted
        // );

        // TODO: Change this to the correct permission later
        const permission = response.data[0];

        console.log('Permission:', permission); 
        
        return permission ? permission.can_read : false;
      })
    );
  }

  // Debug method to test cookie sending
  testCookieSending(): Observable<unknown> {
    console.log('Testing cookie sending...');
    console.log('Document cookies:', document.cookie);
    console.log('Access token from cookie:', this.getCookie('access_token'));
    
    return this.http.get(this.authUrl + 'test-cookies', {
      withCredentials: true,
    });
  }
}
